export default __webpack_public_path__ + "static/media/infinty-wallet.5387f26b.jpeg";